import { Injectable } from '@angular/core';

/**
 * Обертка для плагина /assets/spatial-navigation.service.js Перемещение курсора, по HTML элементам, стрелочными кнопками.
 * Элементы по которым происходит перемещение должны иметь атрибут tabindex='1' Значение индекса не имеет особого значения. 
 * Перемещение происходит по близлежащему элементу. Курсор автоматически перемещается по элементам формы. Чтобы их исключить из 
 * фокуса надо указать tabindex="-1"
 */
@Injectable({providedIn: 'root'})
export class SpatialNavigationService {
    
    constructor() { }
    
    /**
     * Сбрасывает настройки Spatial Navigation. Необходимо если удаляются элменты на странице и порядок меняется.
     */
    reset(){
        if('spatialNavigationReset' in window){
            (<any>window).spatialNavigationReset();
        }
    }
    
}